import { render } from "./CenterDetails.vue?vue&type=template&id=fc75bd14&scoped=true"
import script from "./CenterDetails.vue?vue&type=script&lang=js"
export * from "./CenterDetails.vue?vue&type=script&lang=js"

import "./CenterDetails.vue?vue&type=style&index=0&id=fc75bd14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fc75bd14"

export default script